import { notificationsQueryOptions, unreadCountQueryOptions } from '@/api/queries/notifications';
import { useAuthStatus } from '@/hooks/use-auth-status';
import { useQuery } from '@tanstack/react-query';

export { NOTIFICATIONS_QUERY_KEYS } from '@/api/queries/notifications';

/**
 * Hook to fetch notifications data using TanStack Query
 * Uses domain-oriented query options
 */
export function useNotifications() {
  const authStatus = useAuthStatus();
  return useQuery({
    ...notificationsQueryOptions(),
    enabled: authStatus === 'verified',
  });
}

/**
 * Hook to fetch unread notifications count
 * Automatically refetches periodically and when notifications change
 */
export function useUnreadCount() {
  const authStatus = useAuthStatus();
  return useQuery({
    ...unreadCountQueryOptions(),
    enabled: authStatus === 'verified',
  });
}
